import React, { useEffect, useState } from "react";
import Faq from "./Faq";
import axios from "axios";

export default function FaqSection() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    axios
      .get("/faqs")
      .then(({ data }) => {
        if (data) {
          setFaqs(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);  

  const faqElements = faqs.map((faq) => <Faq faq={faq} key={faq._id} />);
  return (
    <section className="fag_section">
      <h2>FAQS</h2>
      <div className="faq_container">
        {faqElements}
      </div>
    </section>
  );
}
